import type { ReactNode } from 'react'

import { errorMessage } from '@/api/client'
import { cn } from '@/lib/cn'

import { Icon } from './Icon'

/** Ошибка под формой или блоком: текст из ApiError или переданный явно. */
export function ErrorText({
  error,
  children,
  className,
}: {
  error?: unknown
  children?: ReactNode
  className?: string
}) {
  const text = children ?? (error ? errorMessage(error) : null)
  if (!text) return null
  return (
    <p role="alert" className={cn('flex items-start gap-2 text-sm text-danger', className)}>
      <Icon name="alert" size={18} className="mt-px shrink-0" />
      <span className="min-w-0">{text}</span>
    </p>
  )
}
